import styled from "styled-components";
import type { FC } from "react";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { ToggleFilter } from "pro-features/components/filtersPanel/src/ToggleFilter";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { swSettings } from "app/common/services/swSettings";
import { SwitcherGranularityContainer } from "app/pages/website-analysis/components/SwitcherGranularityContainer";
import type {
    EIndustriesType,
    IFilters,
} from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import categoryService from "app/common/services/categoryService";

const RightContainer = styled(BaseFlex)`
    gap: 16px;
    align-items: center;
`;

const Container = styled(BaseFlex)<{ displayIndustriesTypeToggle: boolean }>`
    flex: 1 1 auto;
    justify-content: ${({ displayIndustriesTypeToggle }) =>
        displayIndustriesTypeToggle ? "space-between" : "flex-end"};
    padding-left: 40px;
`;

interface IActionButtons {
    isFavoritesToggleDisabled: boolean;
    onIsFavoriteToggle: VoidFunction;
    favoritesAmount: number;
    excelLink: string;
    industriesType: EIndustriesType;
    onIndustriesTypeToggle: (index: EIndustriesType) => void;
    filters: IFilters;
}

export const ActionButtons: FC<IActionButtons> = (props) => {
    const {
        onIsFavoriteToggle,
        favoritesAmount,
        excelLink,
        isFavoritesToggleDisabled,
        industriesType,
        onIndustriesTypeToggle,
        filters,
    } = props;
    const { isFavorites, selectedIndustry } = filters;
    const { children: selectedIndustryChildren = [], id: selectedIndustryId } = selectedIndustry;
    const flattenedSelectedIndustry = categoryService
        .getFlattenedCategoriesList()
        .find((industry) => industry.id === selectedIndustryId);
    const trackingCallback = () =>
        allTrackers.trackEvent("Download", "submit-ok", "Table/Excel/Cross industry overview");
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const displayIndustriesTypeToggle = selectedIndustryChildren.length === 0 && !flattenedSelectedIndustry.isChild;
    return (
        <Container displayIndustriesTypeToggle={displayIndustriesTypeToggle}>
            {displayIndustriesTypeToggle && (
                <SwitcherGranularityContainer
                    itemList={[
                        { title: translate("pre.defined.industries.table.industry.type.all") },
                        { title: translate("pre.defined.industries.table.industry.type.main") },
                    ]}
                    selectedIndex={industriesType}
                    onItemClick={onIndustriesTypeToggle}
                    customClass={"CircleSwitcher"}
                />
            )}

            <RightContainer>
                <ToggleFilter
                    isActive={isFavorites}
                    onClick={onIsFavoriteToggle}
                    isDisabled={isFavoritesToggleDisabled}
                    label={translate("pre.defined.industries.table.favorites.toggle", {
                        favoritesAmount,
                    })}
                    tooltip={translate("pre.defined.industries.table.favorites.toggle.tooltip")}
                />
                <DownloadButtonMenu
                    Excel={true}
                    downloadUrl={excelLink}
                    excelLocked={!downloadExcelPermitted}
                    trackingFunction={trackingCallback}
                />
            </RightContainer>
        </Container>
    );
};
